<template>
  <v-card class="card-quote" elevation="0">
    <v-card-text>
      <v-row class="px-5">
        <v-col cols="12" class="pb-5" style="color: var(--v-darkblue-base); font-weight: bold; font-size: 16px;">
          <!-- <v-img src="img/icons/quote_kit_data_information.png" width="416" contain></v-img> -->
          <div
            class="d-flex flex-row align-center">
            <v-sheet
              color="title-icon"
              class="d-flex justify-center align-center rounded-circle"
              height="38"
              width="38">
              <v-icon color="title-icon-background" size="20">fas fa-edit</v-icon>
            </v-sheet>
            <span
              class="title-foreground--text font-weight-medium ml-2">
              Preencher os campos abaixo para enviar o Kit:
            </span>
          </div>
        </v-col>

        <v-col cols="12" md="3" class="component-col pr-md-0 mr-md-0 py-0 my-0">
          <v-text-field
            label="CNPJ"
            maxlength="18"
            v-model="juridicalPersonKit.cnpj"
            v-mask="$util.formmasks.cnpj"
            :rules="[$util.formrules.cnpj]"
            @input="() => setJuricalPersonKitCNPJ(juridicalPersonKit.cnpj)"
            validate-on-blur
            outlined
            readonly
            dense
          />
        </v-col>
        <v-col cols="12" md="7" class="component-col pl-md-1 pr-md-0 mr-md-0 py-0 my-0">
          <v-text-field
            label="Razão Social"
            v-model="juridicalPersonKit.legalName"
            :rules="[$util.formrules.required]"
            @input="() => setJuricalPersonKitLegalName(juridicalPersonKit.legalName)"
            maxlength="255"
            validate-on-blur
            outlined
            readonly
            dense
          />
        </v-col>
        <v-col cols="12" md="2" class="component-col pl-md-1 pr-md-0 mr-md-0 py-0 my-0">
          <v-text-field
            label="Data de Vigência"
            v-model="juridicalPersonKit.effectiveDate"
            v-mask="$util.formmasks.date"
            placeholder="__/__/____"
            :rules="[$util.formrules.required]"
            @input="() => setJuricalPersonKitEffectiveDate(juridicalPersonKit.effectiveDate)"
            maxlength="10"
            validate-on-blur
            outlined
            dense
          />
        </v-col>
        <v-col cols="12" md="3" class="component-col pr-md-0 mr-md-0 py-0 my-0">
          <v-text-field
            label="CEP"
            v-model="juridicalPersonKit.addressZip"
            v-mask="$util.formmasks.cep"
            :rules="[$util.formrules.cep]"
            @input="() => { loadAddressByZipCode(juridicalPersonKit.addressZip); setJuricalPersonKitAddressZip(juridicalPersonKit.addressZip); }"
            :loading="loadingZipCode"
            maxlength="9"
            validate-on-blur
            outlined
            clearable
            dense
          />
        </v-col>
        <v-col cols="12" md="4" class="component-col pr-md-0 mr-md-0 py-0 my-0">
          <v-text-field
            label="Logradouro"
            v-model="juridicalPersonKit.address"
            :rules="[$util.formrules.required]"
            @input="() => setJuricalPersonKitAddress(juridicalPersonKit.address)"
            maxlength="255"
            validate-on-blur
            outlined
            clearable
            dense
          />
        </v-col>
        <v-col cols="12" md="2" class="component-col pr-md-0 mr-md-0 py-0 my-0">
          <v-text-field
            label="Número"
            v-model="juridicalPersonKit.addressNumber"
            @input="() => setJuricalPersonKitAddressNumber(juridicalPersonKit.addressNumber)"
            @keydown="$util.acceptOnlyNumbers"
            :rules="[$util.formrules.required]"
            maxlength="6"
            validate-on-blur
            outlined
            clearable
            dense
          />
        </v-col>
        <v-col cols="12" md="3" class="component-col pr-md-0 mr-md-0 py-0 my-0">
          <v-text-field
            label="Complemento"
            v-model="juridicalPersonKit.addressComplement"
            @input="() => setJuricalPersonKitAddressComplement(juridicalPersonKit.addressComplement)"
            maxlength="255"
            validate-on-blur
            outlined
            clearable
            dense
          />
        </v-col>
        <v-col cols="12" md="5" class="component-col pr-md-0 mr-md-0 py-0 my-0">
          <v-text-field
            label="Bairro"
            v-model="juridicalPersonKit.addressNeighborhood"
            :rules="[$util.formrules.required]"
            @input="() => setJuricalPersonKitAddressNeighborhood(juridicalPersonKit.addressNeighborhood)"
            maxlength="255"
            validate-on-blur
            outlined
            clearable
            dense
          />
        </v-col>
        <v-col cols="12" md="2" class="component-col pr-md-0 mr-md-0 py-0 my-0">
          <v-text-field
            label="UF"
            v-model="juridicalPersonKit.addressState"
            :rules="[$util.formrules.required]"
            @input="() => setJuricalPersonKitAddressState(juridicalPersonKit.addressState)"
            maxlength="2"
            validate-on-blur
            outlined
            readonly
            dense
          />
        </v-col>
        <v-col cols="12" md="5" class="component-col pr-md-0 mr-md-0 py-0 my-0">
          <v-text-field
            label="Cidade"
            v-model="juridicalPersonKit.addressCity"
            :rules="[$util.formrules.required]"
            @input="() => setJuricalPersonKitAddressCity(juridicalPersonKit.addressCity)"
            maxlength="255"
            validate-on-blur
            outlined
            readonly
            dense
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import ViaCepService from "@/services/address/ViaCepService";

export default {
  name: 'juridicalPersonDataKit',
  data: () => ({
    loadingZipCode: false,
    juridicalPersonKit: {
      cnpj: null,
      legalName: null,
      effectiveDate: null,
      address: null,
      addressZip: null,
      addressNeighborhood: null,
      addressNumber: null,
      addressComplement: null,
      addressCity: null,
      addressState: null,
    }
  }),
  props: {
    quoteData: {
      type: Object,
      required: true,
    }
  },
  computed: {
    ...mapGetters(['juridicalPersonKitObj']),
  },
  methods: {
    ...mapMutations(["showmsg"]),
    ...mapActions(['setJuricalPersonKitCNPJ', 'setJuricalPersonKitLegalName', 'setJuricalPersonKitEffectiveDate', 'setJuricalPersonKitAddressZip', 
      'setJuricalPersonKitAddress', 'setJuricalPersonKitAddressNumber', 'setJuricalPersonKitAddressComplement',
      'setJuricalPersonKitAddressNeighborhood', 'setJuricalPersonKitAddressState', 'setJuricalPersonKitAddressCity']),
    loadJuricalPersonKitData() {
      if(this.quoteData && this.quoteData.juridicalPersonObj) {
        this.juridicalPersonKit.cnpj = this.quoteData.juridicalPersonObj.cnpj;
        this.setJuricalPersonKitCNPJ(this.juridicalPersonKit.cnpj);
        
        this.juridicalPersonKit.legalName = this.quoteData.juridicalPersonObj.legalName;
        this.setJuricalPersonKitLegalName(this.juridicalPersonKit.legalName);

        if(this.quoteData.juridicalPersonObj.city) {
          this.juridicalPersonKit.addressCity = this.quoteData.juridicalPersonObj.city.name;
          this.setJuricalPersonKitAddressCity(this.juridicalPersonKit.addressCity);
          
          if(this.quoteData.juridicalPersonObj.city.state_id) {
            this.juridicalPersonKit.addressState = this.quoteData.juridicalPersonObj.city.state_id.code;
            this.setJuricalPersonKitAddressState(this.juridicalPersonKit.addressState);
          }
        }
      }
      
      if(this.quoteData && this.quoteData.juridicalPersonKitObj) {
        this.juridicalPersonKit.address = this.quoteData.juridicalPersonKitObj.address;
        this.juridicalPersonKit.addressZip = this.quoteData.juridicalPersonKitObj.addressZip;
        this.juridicalPersonKit.addressNumber = this.quoteData.juridicalPersonKitObj.addressNumber;
        this.juridicalPersonKit.addressNeighborhood = this.quoteData.juridicalPersonKitObj.addressNeighborhood;
        this.juridicalPersonKit.addressComplement = this.quoteData.juridicalPersonKitObj.addressComplement;
        
        this.setJuricalPersonKitAddress(this.juridicalPersonKit.address);
        this.setJuricalPersonKitAddressZip(this.juridicalPersonKit.addressZip);
        this.setJuricalPersonKitAddressNumber(this.juridicalPersonKit.addressNumber);
        this.setJuricalPersonKitAddressNeighborhood(this.juridicalPersonKit.addressNeighborhood);
        this.setJuricalPersonKitAddressComplement(this.juridicalPersonKit.addressComplement);
      }
    },
    async loadAddressByZipCode(zipCode) {
      zipCode = this.$util.removeMask(zipCode);
      
      if(zipCode && zipCode.trim().length === 8 && !this.loadingZipCode) {
        this.loadingZipCode = true;

        await this._viaCepService.findAddressByZipCode(zipCode)
          .then((response) => {
            if(response && response.data) {
              if(this.juridicalPersonKit.addressCity && response.data.localidade.toUpperCase() === this.juridicalPersonKit.addressCity.toUpperCase()) {
                this.juridicalPersonKit.address = response.data.logradouro;
                this.juridicalPersonKit.addressNeighborhood = response.data.bairro;
                this.juridicalPersonKit.addressComplement = response.data.complemento;
                this.setJuricalPersonKitAddress(this.juridicalPersonKit.address);
                this.setJuricalPersonKitAddressNeighborhood(this.juridicalPersonKit.addressNeighborhood);
                this.setJuricalPersonKitAddressComplement(this.juridicalPersonKit.addressComplement);
              } else {
                this.clearAddressFields();
                this.showmsg({text: 'O CEP informado não corresponde à cidade informada na etapa anterior.', type: 'warning'});
              }
            }
          })
          .catch(() => {
            this.clearAddressFields();
            this.showmsg({text: 'Não foi possível validar o CEP informado.<br/>' +
                'Por favor, verifique se o CEP informado está correto e continue com o preenchimento do formulário.', type: 'warning'});
          })
          .finally(() => {
            this.loadingZipCode = false;
            this.$emit('resetValidationFields');
          });
      }
    },
    clearAddressFields() {
      this.juridicalPersonKit.address = null;
      this.juridicalPersonKit.addressNeighborhood = null;
      this.juridicalPersonKit.addressComplement = null;
      this.setJuricalPersonKitAddress(this.juridicalPersonKit.address);
      this.setJuricalPersonKitAddressNeighborhood(this.juridicalPersonKit.addressNeighborhood);
      this.setJuricalPersonKitAddressComplement(this.juridicalPersonKit.addressComplement);
    }
  },
  beforeCreate() {
    this._viaCepService = new ViaCepService();
  },
  created() {
    this.loadJuricalPersonKitData();
  },
};
</script>

<style scoped>

.component-col {
  height: 62px !important;
}

.component-col-text {
  height: 40px !important;
}

</style>
